/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import get from 'lodash/get';
import { isInWechatMobile, isInMobileDevice } from '@/utils/environment';
import { createPayment } from '@/utils/create-payment';
import store from '@/store';
import { USER } from '@/store/types';
import * as api from '@/api/user';
import mineModule, { StoreUserCodeMineState } from './mine';
import adminModule, { StoreUserCodeAdminState } from './admin';

export interface StoreUserCodeState {
  // modules
  mine: StoreUserCodeMineState;
  admin: StoreUserCodeAdminState;
}

export default {
  namespaced: true,
  modules: {
    mine: mineModule,
    admin: adminModule,
  },
  state: {
    sales: [],
  },
  getters: {},
  actions: {
    [USER.GET_CODE_SALES]({ commit }, { prefix }) {
      return new Promise((resolve, reject) => {
        api.getCodeSales(prefix).then((res) => {
          commit(USER.GET_CODE_SALES, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.EXCHANGE_CODE](_, { feature }) {
      return createPayment(() => api.exchangeCode(feature, { errcodeExpected: [445, 446] }));
    },
    [USER.USE_CODE](_, { id }) {
      return new Promise((resolve, reject) => {
        api.useCode(id).then((res) => {
          const oncomplete = (): void => resolve(res);
          Promise.all([
            store.dispatch(`user/code/mine/${USER.GET_CODE_LIST}`),
            store.dispatch(`user/${USER.GET}`, { action: 'refresh' }),
          ]).then(oncomplete).catch(oncomplete);
        }).catch(reject);
      });
    },
    [USER.SET_ORDER](_, { type, fee, goal, attach }) {
      let tradeType = '';
      if (type === 'wxpay') {
        if (isInWechatMobile()) {
          tradeType = 'JSAPI';
        } else if (isInMobileDevice()) {
          tradeType = 'MWEB';
        } else {
          tradeType = 'NATIVE';
        }
      }
      return new Promise((resolve, reject) => {
        api.setOrder(type, { fee, goal, attach, tradeType }).then((res) => {
          if (type === 'wxpay') {
            if (tradeType === 'JSAPI') {
              const WeixinJSBridge = get(window, 'WeixinJSBridge');
              WeixinJSBridge.invoke('getBrandWCPayRequest', res.data, (response) => {
                if (response.err_msg === 'get_brand_wcpay_request:ok') {
                  Promise.all([
                    store.dispatch(`user/${USER.GET}`, { action: 'refresh' }),
                    store.dispatch(`user/coin/mine/${USER.GET_COIN_TRANSFER_INFO}`, { refresh: true }),
                  ]).then(() => {
                    resolve();
                  }).catch(() => {
                    resolve();
                  });
                } else {
                  reject();
                }
              });
            } else if (tradeType === 'MWEB') {
              if (res.errcode === 0 && res.data.mwebUrl) {
                window.location.href = res.data.mwebUrl;
              } else {
                reject(new Error(res.errmsg));
              }
            } else if (res.errcode === 0 && res.data.qrcodeUrl) {
              resolve(res);
            } else {
              reject(new Error(res.errmsg));
            }
          } else if (type === 'hmpay') {
            resolve();
          }
        }).catch(reject);
      });
    },
    [USER.GET_ORDER](_, { id, silent }) {
      return new Promise((resolve, reject) => {
        api.getOrder(id, silent).then((res) => {
          resolve(res);
        }).catch(reject);
      });
    },
    [USER.EXCHANGE_USE_CODE](_, { feature, extra }) {
      return new Promise((resolve, reject) => {
        api.exchangeUseCode(feature, extra).then((res) => {
          const ps: Promise<void>[] = [];
          // 修改游戏信息页面刷新游戏信息
          ps.push(store.dispatch(`user/profile/${USER.GET_GAME_OPTIONS}`, { action: 'refresh', scene: 'detail', id: extra }));
          Promise.all(ps).then(() => { resolve(res); }).catch(reject);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_CODE_SALES](state, sales) {
      state.sales = sales;
    },
  },
};
